export function Shop({
  inputData,
  colorTheme,
  pageData,
  headlineStart,
  headlineEnd
}) {
  return `<!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content="${inputData.subheading}" />
      <link rel="icon" type="image/png" sizes="32x32" href="./favicon-32x32.png">
      <link rel="icon" type="image/png" sizes="16x16" href="./favicon-16x16.png">
      <link rel="apple-touch-icon" sizes="180x180" href="./apple-touch-icon.png">
      <link rel="icon" type="image/png" sizes="512x512" href="./android-chrome-512x512.png">
      <link rel="icon" type="image/png" sizes="192x192" href="./android-chrome-192x192.png">
      <link rel="manifest" href="./site.webmanifest">
      <title>${inputData.main_headline}</title>
      <style>
        :root {
          --main-color: #ff6f61;
          --text-color: #fff0ee;
          --banner-image: url("${inputData.background_image}")  center top / cover no-repeat;
        }
        *,
        *::before,
        *::after {
          box-sizing: border-box;
          user-select: none;
        }
        body {
          font-family: "Helvetica Neue", sans-serif;
          margin: 0;
          padding: 0;
          background-color: #fafafa;
          color: #333;
          line-height: 1.6;
          min-width: 450px;
        }
        nav {
          background: #fff;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          padding: 1rem;
          position: sticky;
          top: 0;
          z-index: 10;
        }
        nav a {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 24px;
        }
        @media screen and (max-width: 400px) {
          nav a {
            font-size: 20px;
          }
        }
        nav a:hover {
          color: var(--main-color);
        }
        @media (min-width: 700px) {
          .hero {
            min-height: 50vh;
          }
        }
        .hero {
          background: var(--banner-image);
          color: white;
          text-align: center;
          padding: 6rem 2rem;
        }
        .hero h1 {
          font-size: 2.8rem;
          margin-bottom: 1rem;
        }
        .btnDiv {
          padding: 1em;
          display: flex;
          justify-content: flex-end;
        }
        .btn {
          background: var(--main-color);
          color: white;
          padding: 0.75rem 1.5rem;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
          margin-top: 1rem;
          font-weight: bold;
        }
        .btn:hover {
          background: #e65b51;
        }
        .section {
          padding: 4rem 2rem;
          max-width: 1100px;
          margin: auto;
        }
        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 2rem;
          margin-top: 2rem;
        }
        .card {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          transition: transform 0.2s ease;
        }
        .card:hover {
          transform: translateY(-5px);
        }
        .card img {
          padding: 0.5rem;
          height: 180px;
          object-fit: contain;
        }
        .card h3 {
          margin: 1rem;
          color: var(--main-color);
        }
        .card p {
          margin: 0 1rem 1.5rem;
          color: #555;
        }
        footer {
          background: #333;
          color: #ccc;
          text-align: center;
          padding: 0.5rem;
        }
        footer a {
          color: #e1306c;
          text-decoration: none;
          font-weight: 600;
        }
        footer a:hover {
          text-decoration: underline;
        }

.cart-count {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 50%;
  background-color: #eee;
  color: var(--main-color);
  font-weight: bolder;
  user-select: none;
}

#cartModal,
#customerPaymentInfo {
  border-radius: 5px;
}

#cartModal {
  padding: 0.5em;
  background-color: #fff;
}

#checkoutModal {
  display: none;
  position: fixed;
  text-align: center;
  top: 4rem;
  right: 0;
  background-color: var(--text-color);
  padding: 0.5em;
  height: 100%;
  border-radius: 5px;
  grid-template-columns: 300px 300px;
  gap: 10px;
  direction: rtl;
}

#checkoutModal > * {
  direction: ltr;
}

.cart-item {
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-template-rows: auto auto;
  gap: 10px;
  align-items: center;
  margin: 10px 5px;
}

.cart-item img {
  grid-row: span 2;
  width: 60px;
  object-fit: cover;
  border-radius: 5px;
}

.item-info {
  display: flex;
  justify-content: space-between;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quantity-controls button {
  width: 50px;
  padding: 5px;
  height: 30px;
  font-size: 1.2rem;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.cart-item p {
  margin: 0;
  font-size: 0.9rem;
}

.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #555;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

a svg {
  vertical-align: middle;
}

.facebook-icon {
  color: #1877f2;
}

.instagram-icon {
  color: #e1306c;
}

.space-between {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.input-group {
  display: flex;
  /* width: 450px; */
  width: 100%;
  max-width: 450px;
}

.input-group input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-right: none;
  outline: none;
}

.input-group button {
  padding: 10px 16px;
  border: 1px solid #ccc;
  color: white;
  cursor: pointer;
  user-select: none;
}

.input-group button:hover {
  background: #555;
}

.prefooterDiv {
  background-color: #f2f5fc;
  padding: 10px;
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.prefooterDiv div {
  flex: 1;
}

.prefooterDiv div h3 {
  text-transform: uppercase;
  font-weight: bolder;
  margin-bottom: 4px;
}

@media (max-width: 768px) {
  .prefooterDiv {
    flex-direction: column;
  }
  .prefooterDiv div {
    justify-items: center;
  }
  .prefooterDiv div h3,
  .prefooterDiv div {
    text-align: center;
  }
  .grid,
  #checkoutModal {
    grid-template-columns: 1fr;
  }
}

table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #ddd;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr:hover {
  background-color: #ddd;
}

th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  font-weight: bolder;
}

      </style>
    </head>
    <body>
      <nav>
      <a href="/"><img alt="brand_logo" src="./android-chrome-192x192.png" width="20"/>
        &nbsp;<span id="navtitle">${inputData.brand_name}</span></a>
        <a style="float:right;cursor: pointer;" id="shopping-cart">🛒<span class="cart-count" id="cartCount"></span></a>
      </nav>
      <section class="hero">
        <h1 id="bannertxt"></h1>
      </section>
      <p style="text-align: center;">${inputData.subheading}</p>
      <section class="section">
        <div class="grid" id="menuGrid"></div>
      </section>
      <section id="checkoutModal">
        <div id="cartModal">
          <button style="width: 100%;" class="btn close-cart">X</button>
          <div id="cartItems"></div>
          <button style="width: 100%;" class="btn checkout">
            <span class="btn-text">Checkout</span>
            <span class="spinner" style="display:none;">⏳</span>
          </button>
        </div>
        <div id="customerPaymentInfo"></div>
      </section>
      <div id="success-popup" style="display:none; position:fixed; top:0; left:0; right:0; bottom:0; background: rgba(0,0,0,0.5); justify-content:center; align-items:center; z-index:9999;">
        <div style="background:white; border-radius:12px; padding:2rem; max-width:500px; width:90%; text-align:center; font-family:sans-serif;">
          <div style="font-size:2rem; color:green; margin-bottom:1rem;" id="orderconfirm-check">✔️</div>
          <h2 style="font-weight:bold; margin-bottom:1rem;" id="orderconfirm-header">Order Confirmed! 🎉</h2>
          <div style="background-color:#EEF5F3; padding:1rem; margin:1rem 0; border-radius:6px;">
            Order Number<br>
            <span id="order-id" style="font-weight:bold;"></span>
          </div>
          <p id="orderconfirm-message"></p>
          <button class="btn" onclick="window.location.href='/'">
            Continue Shopping
          </button>
        </div>
      </div>
      <div class="prefooterDiv">
        <div id="subscribe" style="display:none;">
          <h3 style="text-align:center;">Stay Updated</h3>
          <span>Get updates on new features, templates, and improvements.</span>
          <div class="input-group">
            <input type="email" id="subscribeInfo" placeholder="Email Address" />
            <button class="subscribe">Get Updates</button>
          </div>
          <span id="subscribeMessage"></span>
        </div>
        <div>
          <h3 style="text-align: center;">Contact</h3>
          <p style="text-align: center;"><span id="address"></span><span id="phone"></span><span
              id="email"></span><span id="socialmedia"></span>
          </p>
        </div>
      </div>
      <footer>
        <div>
          &copy; ${new Date().getFullYear()} ${inputData.brand_name}. Website template by <a style="text-decoration: underline;" target="_blank"
          href="https://wendaspace.com">Wendaspace</a>
        </div>
      </footer>
      <script>
        let currencyVal = "$";
        let confirmationMessage = "We will send a confirmation email with your order details.";
        const APPSCRIPT_URL = ${inputData.submit_url};
        const cartName = "${inputData.brand_name}-cart";
        loadAccount();
        orderConfirmation();
        init();

        async function postRequest(action, data) {
          const response = await fetch(APPSCRIPT_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
          });
          if (!response.ok) {
            throw new Error("HTTP error! Status:" + response.status);
          }
          return await response.json();
        }

        async function loadAccount() {
          const brandName = "${inputData.brand_name}";
          const address = "${inputData.address}";
          const email = "${inputData.email}";
          const phone = "${inputData.phone}";

          // branding
          const logo = "${inputData.logo}";
          const bannerText = "${inputData.main_headline}";
          const mainColor = "${inputData.primary_color}";

          // store
          const currency = "${inputData.currency}";
          const orderMessage = "${inputData.order_confirmation_text}";

          // socialmedia
          const instagram = "${inputData.instagram_link}";
          const facebook = "${inputData.facebook_link}";

          // subscribe
          const subscriptionInstruc = "${inputData.subscribe_instructions}";
          
          document.documentElement.style.setProperty("--main-color", mainColor);
          const textColor = "${colorTheme.warmAccent}";
          document.documentElement.style.setProperty("--text-color", textColor);
          if (address) document.getElementById("address").textContent = "🏠"+ address + " |";
          if (phone) document.getElementById("phone").textContent = "📞"+ phone + " |";
          if (email) document.getElementById("email").textContent = " 📧" + email;
          document.getElementById("bannertxt").textContent = bannerText;
          let socialMedia = "";
          if (instagram) {
            socialMedia =  '<a target="_blank" href=instagram><svg class="instagram-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M7.75 2h8.5C19.99 2 22 4.01 22 6.25v11.5C22 19.99 19.99 22 16.25 22h-8.5C4.01 22 2 19.99 2 17.75V6.25C2 4.01 4.01 2 7.75 2Zm0 1.5A4.76 4.76 0 0 0 3.5 6.25v11.5A4.76 4.76 0 0 0 7.75 20.5h8.5a4.76 4.76 0 0 0 4.75-4.75V6.25A4.76 4.76 0 0 0 16.25 3.5h-8.5Zm10.5 2a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"/></svg></a>';
          }
          if (facebook) {
            socialMedia +=  '<a target="_blank" href=facebook><svg class="facebook-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-label="Facebook"><path d="M22 12.07C22 6.48 17.52 2 11.93 2 6.35 2 1.87 6.48 1.87 12.07c0 4.99 3.65 9.13 8.43 9.93v-7.03H7.9v-2.9h2.4V9.41c0-2.37 1.41-3.68 3.57-3.68 1.03 0 2.1.18 2.1.18v2.31h-1.18c-1.16 0-1.52.72-1.52 1.46v1.75h2.59l-.41 2.9h-2.18V22c4.78-.8 8.43-4.94 8.43-9.93Z"/></svg></a>';
          }
          document.getElementById("socialmedia").innerHTML = "<br />"+socialMedia;

          let link = document.querySelector("link[rel~='icon']");
          link.href = logo;
          const navTitle = document.getElementById("navtitle")
          navTitle.textContent = brandName;
          navTitle.style.color = mainColor;

          currencyVal = currency;
          if (orderMessage) confirmationMessage = orderMessage; 
          
          const subscribediv = document.getElementById("subscribe");
          const spanEl = subscribediv.querySelector("span");
          spanEl.textContent = subscriptionInstruc;
          const inputEl = subscribediv.querySelector("input");
          inputEl.placeholder = "Email";
          subscribediv.style.display = "block";
          const buttonEl = subscribediv.querySelector("button");
          buttonEl.style.backgroundColor = mainColor;
          buttonEl.style.color = textColor;
        };

        async function init() {
          await loadMenu();

          loadCart();
        };
        
        async function loadMenu() {
          const menuGrid = document.getElementById("menuGrid");
          menuGrid.innerHTML = "<div style='display: flex; justify-content: center; font-size: 24px';><div class='spinner'></div></div>";
          let menu = ${JSON.stringify(pageData)};
          if (!menu || menu === null) menu = [];
          if (menu.length === 0) {
            menuGrid.innerHTML = "<div style='display: flex; justify-content: center; font-size: 24px;'><div>NO DATA</div></div>";
            return;
          }

          let menuDiv = "";
          for (const m of menu) {
            menuDiv += "<div class='card'><img src="+m.imageUrl+" style='display: block' alt="+m.title+" /><div class='space-between'><div><h3>"+m.title+"</h3></div><div><p style='margin: 1rem; font-weight: bolder; font-size: 14px; color: red;'>"+currencyVal + m.price+"</p></div></div><p>"+m.description+"</p><div class='btnDiv'><button class='btn add-to-cart' data-id="+m.title+" data-name="+m.title+" data-price="+m.price+" data-image="+m.imageUrl+">Add To Cart</button></div></div>";
          }
          menuGrid.innerHTML = menuDiv;
        };
        document.addEventListener("click", (e) => {
          const btn = e.target;
          if (e.target.classList.contains("add-to-cart")) {
            addToCart(
              btn.dataset.id,
              btn.dataset.name,
              btn.dataset.price,
              btn.dataset.image
            );
          }

          if (e.target.classList.contains("increase-quantity")) {
            increaseQuantity(btn.dataset.id);
          }

          if (e.target.classList.contains("decrease-quantity")) {
            decreaseQuantity(btn.dataset.id);
          }

          if (e.target.classList.contains("close-cart")) {
            closeCart();
          }

          if (e.target.classList.contains("checkout")) {
            handleCheckout(e);
          }

          if (e.target.classList.contains("subscribe")) {
            handleSubscription(e);
          }
        });

        async function handleSubscription(e) {
          const btn = e.target;
          btn.disabled = true;
          btn.style.pointerEvents = "none";
          const inputElement = document.getElementById("subscribeInfo");
          const inputValue = inputElement.value;
          if (!inputValue) return;
          btn.textContent = "Submitting...";
          const msg = document.getElementById("subscribeMessage");
          msg.style.fontSize = "11px";
          try {
            const payload = {
              subscriber: inputValue,
              type: "subscribe"
            }
            await postRequest("subscribe", payload);
            msg.textContent = "Successful";
            msg.style.color = "green";
            inputElement.value = "";
          } catch (error) {
            console.error(error);
            msg.textContent = "Failed. Please try again.";
            msg.style.color = "red";
          }
          msg.style.display = "block";
          btn.textContent = "Get Updates";
          var x = setInterval(function () {
            clearInterval(x);
            msg.style.display = "none";
          }, 10000);
        }

        function loadCart() {
          const cart = JSON.parse(localStorage.getItem(cartName) || "[]");
          if (cart.length === 0) closeCart();
          document.getElementById("cartCount").textContent = cart.reduce((acc, item) => acc + item.quantity, 0);
          let cartItemDiv = "";
          for (const c of cart) {
            const total = (c.price * c.quantity).toFixed(2);
            cartItemDiv += "<div class='cart-item'><img src="+ c.imageUrl +" alt="+ c.title +" /><div class='item-info'><p>"+ c.title +"</p><p>"+ currencyVal + total +"</p></div><div class='quantity-controls'><button class='btn decrease-quantity' data-id="+ c.title +">-</button><span>"+c.quantity+"</span><button class='btn increase-quantity' data-id="+c.title +">+</button></div></div>";
          }
          const cartTotal = cart.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2);
          const cartTotalDiv = "<div><table style='width: 100%;'><tr><td align='left'>Total</td><td style='font-weight: bolder;' align='right'>"+currencyVal + cartTotal +"</td></tr></table></div>";
          const cartItems = document.getElementById("cartItems");
          cartItems.innerHTML = cartItemDiv;
          cartItems.innerHTML += cartTotalDiv;

          const customerPaymentInfo = document.getElementById("customerPaymentInfo");
          let customerPaymentDiv = "<div style='padding-bottom: 2rem; background-color: #fff; text-align: left; border-radius: 5px;'><h3 style='text-decoration: underline; font-weight: bold; text-align: center;'>Payment Methods</h3>";
          customerPaymentDiv += "<p style='padding-left: 5px;'>${inputData.payment_instruction}</p>";
          customerPaymentDiv += "</div>";
          customerPaymentDiv += "<div style='padding-bottom: 2rem; background-color: #fff; text-align: left; border-radius: 5px;'><h3 style='text-decoration: underline; font-weight: bold; text-align: center;'>Customer Details</h3>";
          customerPaymentDiv += "<span style='margin-left: 5px;'>Name*</span> <br/><input name='fullname' style='margin-left: 5px; margin-bottom: 5px; width: 95%; height:30px; border-radius: 4px;'/>";
          customerPaymentDiv += "<span style='margin-left: 5px;'>Email Address*</span> <br/><input name='email' style='margin-left: 5px; margin-bottom: 5px; width: 95%; height:30px; border-radius: 4px;'/>";
          customerPaymentDiv += "<span style='margin-left: 5px;'>Phone Number*</span> <br/><input name='phone' style='margin-left: 5px; margin-bottom: 5px; width: 95%; height:30px; border-radius: 4px;'/>";
          customerPaymentDiv += "</div>";
          customerPaymentInfo.innerHTML = customerPaymentDiv;
        }

        document.getElementById("shopping-cart").addEventListener("click", () => {
          if (Number(document.getElementById("cartCount").textContent) === 0) return;
          const checkoutDiv = document.getElementById("checkoutModal");
          checkoutDiv.style.display = "grid";
        });

        function closeCart() {
          const checkoutDiv = document.getElementById("checkoutModal");
          checkoutDiv.style.display = "none";
        };

        async function addToCart(id, name, price, imageUrl) {
          const newCart = { id, title:name, price, imageUrl, quantity: 1 };
          const cart = JSON.parse(localStorage.getItem(cartName) || "[]");
          const matchingItem = cart.find(c => c.id === id);
          if (matchingItem) {
            matchingItem.quantity += 1;
          }
          else {
            cart.push(newCart);
          }

          localStorage.setItem(cartName, JSON.stringify(cart));
          loadCart();
        };

        function increaseQuantity(id) {
          const cart = JSON.parse(localStorage.getItem(cartName) || "[]");
          const matchingItem = cart.find(c => c.id === id);
          if (matchingItem) {
            matchingItem.quantity += 1;
          }
          localStorage.setItem(cartName, JSON.stringify(cart));
          loadCart();
        };

        function decreaseQuantity(id) {
          const cart = JSON.parse(localStorage.getItem(cartName) || "[]");
          const matchingItemIndex = cart.findIndex(c => c.id === id);
          if (matchingItemIndex !== -1) {
            cart[matchingItemIndex].quantity -= 1;
            if (cart[matchingItemIndex].quantity <= 0) {
              cart.splice(matchingItemIndex, 1);
            }
          }
          localStorage.setItem(cartName, JSON.stringify(cart));
          loadCart();
        };

        async function handleCheckout(e) {
          const btn = e.target;
          const payload = {
            type: "checkout",
          }
          payload["customer_details"] = {};

          const customer = {};
          const customerName = document.querySelector('input[name="fullname"]').value;
          if (customerName) customer["name"] = customerName;
          const customerEmail = document.querySelector('input[name="email"]').value;
          if (customerEmail) customer["email"] = customerEmail;
          const customerPhone = document.querySelector('input[name="phone"]').value;
          if (customerPhone) customer["phone"] = customerPhone;
          payload["customer_details"] = customer;
          if (!customerName || (!customerEmail && !customerPhone)) {
            alert("Name and Phone or Email must be provided.");
            return;
          }
          btn.disabled = true;
          btn.style.pointerEvents = "none";
          const text = btn.querySelector(".btn-text");
          const spinner = btn.querySelector(".spinner");

          if (text) text.style.display = "none";
          if (spinner) spinner.style.display = "inline-block";
          const cart = JSON.parse(localStorage.getItem(cartName) || "[]");
          if (cart.length === 0) return;
          const id = crypto.randomUUID();
          payload["cart"] = cart;
          payload["orderId"] = id;

          try {
            await postRequest("checkout", payload);
            window.location.href = "/?orderId="+id;
          }
          catch (error) {
            if (text) text.style.display = "inline-block";
            if (spinner) spinner.style.display = "none";
            console.error("Checkout Error", error);
          }
        };

        async function orderConfirmation() {
          const params = new URLSearchParams(window.location.search);
          const orderId = params.get("order_id");

          if (orderId) {
            const keys = Object.keys(orders).filter(k => k !== "items");
            document.getElementById("orderconfirm-message").textContent = confirmationMessage;
            localStorage.removeItem(cartName);
            document.getElementById("order-id").textContent = orderId;

            document.getElementById("success-popup").style.display = "flex";
            // history.replaceState(null, '', window.location.pathname);
          }
        }
      </script>
    </body>
  </html>`;
}